const RequestTimeSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none"><path fill="#fff" d="M9.008.07a9.007 9.007 0 1 0 0 18.014 9.007 9.007 0 0 0 0-18.013Zm3.603 9.908H9.008a.9.9 0 0 1-.9-.9V3.672a.9.9 0 0 1 1.801 0v4.504h2.702a.9.9 0 0 1 0 1.801Z"/></svg>
    )
}

export default RequestTimeSvg